<div class="auth-transition" [class.is-active]="active" aria-hidden="true">
  <app-grain-pulse
    #pulse
    [listenToService]="false"
  ></app-grain-pulse>
</div>
